import styled, { css } from 'styled-components'
import SearchableSelect from 'components/SearchableSelect'
import { ACCENT, BORDER, INK, MUTED } from './ui'

const pillBase = css`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  flex-shrink: 0;
  min-height: 40px;
  padding: 0 14px;
  border-radius: 20px;
  font: inherit;
  font-size: 14px;
  font-weight: 500;
  white-space: nowrap;
  cursor: pointer;
  transition: border-color 0.15s ease, background-color 0.15s ease;
  border: 1px solid ${({ $active }) => ($active ? INK : BORDER)};
  background: ${({ $active }) => ($active ? INK : '#fff')};
  color: ${({ $active }) => ($active ? '#fff' : INK)};
  &:hover:not(:disabled) { border-color: ${INK}; }
  &:focus-visible { outline: 2px solid ${ACCENT}; outline-offset: 2px; }
  &:disabled { opacity: 0.5; cursor: not-allowed; }
  svg { font-size: 18px; }
`

export const Pill = styled.button`
  ${pillBase}
`

export const PillSelect = styled(SearchableSelect)`
  && {
    ${pillBase}
    width: auto;
    max-width: 240px;
    padding: 0 10px 0 14px;
  }
  && > span { color: inherit; }
`

export const PillCount = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 20px;
  height: 20px;
  padding: 0 6px;
  border-radius: 999px;
  background: ${ACCENT};
  color: #fff;
  font-size: 12px;
  font-weight: 700;
`

export const InlineLabel = styled.span`
  flex-shrink: 0;
  font-size: 14px;
  font-weight: 600;
  color: ${MUTED};
`
